import { call, put, takeLatest } from 'redux-saga/effects';
import { questionsService } from './service';
import {
  GET_QUESTIONS_ANSWERS,
  GET_QUESTIONS_ANSWERS_SUCCESS,
  GET_QUESTIONS,
  GET_QUESTIONS_SUCCESS,
  SUBMIT_QUESTION_ANSWERS,
} from './types';

function* getQuestionsAnswers() {
  try {
    const res = yield call(questionsService.getHistory);
    yield put({
      type: GET_QUESTIONS_ANSWERS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    // yield put(httpRequestsOnErrorsActions.appendError(type, err.data.message));
    // yield put(httpRequestsOnLoadActions.removeLoading(type));
    // yield put(httpRequestsOnErrorsActions.removeError(type));
  }
}
function* getQuestions() {
  try {
    const res = yield call(questionsService.getQuestions);
    yield put({
      type: GET_QUESTIONS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    console.log(err);
  }
}

function* submitQuestionAnswers({ payload }) {
  try {
    yield call(questionsService.submitQuestionAnswers, payload);
  } catch (err) {
    console.log(err);
  }
}

export const watchQuestions = function* watchUserQuestions() {
  yield takeLatest(GET_QUESTIONS_ANSWERS, getQuestionsAnswers);
  yield takeLatest(GET_QUESTIONS, getQuestions);
  yield takeLatest(SUBMIT_QUESTION_ANSWERS, submitQuestionAnswers);
};
